module.exports = __webpack_public_path__ + "img/facebook.aed3e8cd.png";